const NAMESPACE = 'COMMON';
// Clear data
export const CLEAR_DATA_REQ = `${NAMESPACE}/CLEAR_DATA_REQ`;
export const CLEAR_DATA_OK = `${NAMESPACE}/CLEAR_DATA_OK`;
export const CLEAR_DATA_FAIL = `${NAMESPACE}/CLEAR_DATA_FAIL`;
export const GUIDE_COMPLETED = `${NAMESPACE}/GUIDE_COMPLETED`;

export const NETWORK_SELECT = `${NAMESPACE}/NETWORK_SELECT`;
